// ドメイン以降のパスを取得
export const getPathname = () => {
  return window.location.pathname;
};

// ドメイン以降のパスが一致しているか判定
export const isMatchPathname = (pathname: string) => {
  return getPathname() === pathname ? true : false;
};
